import http, {download, uploadCfg} from "../../../utils/HttpUtils";

//销售退货单接口服务
class SaleRoService {
    /*****************************************************************************/

    //新建
    static async insert(data) {
        const apiUrl = "/sale/ro/insert";
        return await http.post(apiUrl, data);
    }

    //修改
    static async update(data) {
        const apiUrl = "/sale/ro/update";
        return await http.post(apiUrl, data);
    }


    //分页查询
    static async findPage(data) {
        const apiUrl = "/sale/ro/findPage";
        return await http.post(apiUrl, data);
    }

    //根据id或code查询
    static async findByIdOrCode(idOrCode) {
        const apiUrl = "/sale/ro/findByIdOrCode/" + idOrCode;
        return await http.get(apiUrl);
    }

    //作废
    static async disable(id) {
        const apiUrl = "/sale/ro/disable/" + id;
        return await http.get(apiUrl);
    }

    //仓库确认
    static async whConfirm(id) {
        const apiUrl = "/sale/ro/whConfirm/" + id;
        return await http.get(apiUrl);
    }

    //结算
    static async settle(data) {
        const apiUrl = "/sale/ro/settle";
        return await http.post(apiUrl, data);
    }

    //导出
    static async export(data) {
        const apiUrl = `/sale/ro/export`;
        return await download(apiUrl, {type: "POST", data});
    }

    /*****************************************************************************/

    //下载明细导入模板
    static async downloadDetailTpl() {
        const apiUrl = `/sale/ro/detail/downloadTpl`;
        await download(apiUrl,)
    }

    //获取导入配置
    static getImportDetailCfg(cfg) {
        const apiUrl = "/sale/ro/detail/import";
        return uploadCfg(apiUrl, cfg);
    }

    /*****************************************************************************/
}

export default SaleRoService;
